import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';

export const Alerts = () => {

    const navigate = useNavigate();

    const alertSuccess = (text_title: string, text_content = '', navigate_route: string | undefined) => {
        try {
            swal({
                title: text_title,
                text: text_content,
                icon: "success",
                button: "Aceptar"
            })
        } catch (e) {
            swal({
                title: "Error inesperado",
                text: "Error inesperado ",
                icon: "error",
                button: "Aceptar"
            })
        }
        if (navigate_route) {
            navigate(navigate_route);
        }
    }

    const showErrorRequest = (error: string, auth) => {
        if (error != null) {
            try {
                swal({
                    title: "Error",
                    text: "Resultado: " + error,
                    icon: "error",
                    button: "Aceptar"
                })
                if (error === "No tiene autorización o su sesión ha expirado") {
                    auth.logout();
                }
            } catch (e) {
                swal({
                    title: "Error",
                    text: "Error inesperado ",
                    icon: "error",
                    button: "Aceptar"
                })
            }
        }
    }

    const warningAlertRequest = (info) => {
        if (info != null) {
            try {
                swal({
                    title: "Alerta",
                    text: info,
                    icon: "warning",
                    button: "Aceptar"
                })

            } catch (e) {
                swal({
                    title: "Error",
                    text: "Error inesperado ",
                    icon: "error",
                    button: "Aceptar"
                })
            }
        }
    }

    return {
        alertSuccess,
        showErrorRequest,
        warningAlertRequest
    }
}